<template>
  <div class="cont mb-5">
    <div class="alert alert-secondary" role="alert">
      The needed documents for verification include a profile picture and a valid identity card. You are adviced to complete the registration on Chrome or Mozilla.
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <h3>Hello, {{this.$auth.user().name}}</h3>
        <div class="row mb-3">
          <div class="col" id="aboutme-container">
            <div class="alert alert-success mb-3">
              <p
                style="text-align:justify"
              >Welcome to Prepclass tutor registration portal. This page contains a picture and video demo that will help you understand what the whole registration process entails. You cannot start your registration without completely watching the demo video, after that, click “Next” at the bottom of this page, and start your registration. However, we advise all prospective tutors to go through this page carefully to fully understand the entire process and avoid not being verified from the first instance due to corrections on their profile.</p>

              <p
                class="pt-3"
                style="text-align: justify"
              >Note that you are not supposed to replicate the picture and the video demo, it is just a guide for you to understand what is needed at every instance. And the best part, you can come back to this page as many times as you want through the registration process; all you will need to do is click on “click here to view Welcome Page” at the top left corner whenever you need to navigate back here. Furthermore, if you want to go back to the point where you were, you can click on “click here to go back ” at the top left corner. No need to worry, all your information will remain intact. This is a perfect time to verify your email, if you do not verify your email you will not be able to go past stage 3.</p>

              <blockquote style="background-color: rgba(255,255,255,0.5);" class="p-3 font-italic">
                <i>Please make sure you fill in all relevant fields else your profile will not be verified. This whole process should take you approximately 45 minutes to complete, Goodluck.</i>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cont mt-5">
      <img class src="../../../assets/hlover.svg" style="height:30px;width:30px;">
      <span class="h5">Getting Started</span>
      <div class="row mt-5">
        <div class="col-sm-12 col-lg-4">
          <h1 class="faded-number">1</h1>
          <div class="top-text font-x2">
            Personal Information
            <div class="mb-3 ml-4" style="font-size:17px">
              <span>
                <i class="fa fa-clock-o pr-2" style="color:#5f9048"></i>
              </span>
              <span style="padding-top:-20px">3 - 4 mins to complete</span>
            </div>
          </div>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Carefully provide personal information, this includes name, contact, address and a bio about yourself.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Note that all information you provide here will be verified using multiple means, make sure all information is correct to the best of your knowledge to avoid not being verified.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> You can also click on “Click here to preview profile” to see what your profile looks like at every point in the registration process.
          </p>
        </div>
        <div class="col-sm-12 col-lg-6 offset-lg-1 mt-5 float-right mxf-3">
          <b-carousel
            id="carousel-1"
            v-model="slide1"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            class="float-right"
            v-viewer
          >
            <!-- Slides with image only -->
            <b-carousel-slide id="caro-1" img-src="static/Step1a.png">You will put in your personal details here(Swipe to see others</b-carousel-slide>
            <b-carousel-slide id="caro-2" img-src="static/Step1b.png">Tell us where you live and where you can teach</b-carousel-slide>
            <b-carousel-slide id="caro-3" img-src="static/Step1c.png">Write about yourself, convince clients you are the right tutor for their learners</b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <div class="row mt-5 mb-5 flex-column-reverse flex-md-row">
        <div class="col-sm-12 col-lg-6 mt-3 mxf-3">
          <b-carousel
            id="carousel-2"
            v-model="slide2"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            v-viewer
          >
            <!-- Slides with image only -->
            <b-carousel-slide id="caro-3" img-src="static/Step2a__.png">Click on add qualification(Swipe to see others)</b-carousel-slide>
            <b-carousel-slide img-src="static/Step2a.png">Add education details</b-carousel-slide>
            <b-carousel-slide id="caro-3" img-src="static/Step2b1.png">Select how long you have been teaching</b-carousel-slide>
            <b-carousel-slide id="caro-3" img-src="static/Step2b2.png">Click add experience and add teaching experience</b-carousel-slide>
            <b-carousel-slide img-src="static/Step2c.png">Add non-teaching work experience</b-carousel-slide>
          </b-carousel>
        </div>

        <div class="col-sm-12 col-lg-4 offset-lg-1 float-right">
          <h1 class="faded-number">2</h1>
          <div class="top-text">
            Educational Background
            <div class="mb-3 ml-4" style="font-size:17px">
              <span>
                <i class="fa fa-clock-o pr-2" style="color:#5f9048"></i>
              </span>
              <span style="padding-top:-20px">5 - 7 mins to complete</span>
            </div>
          </div>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Provide information on your most recent educational qualifications and certifications.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Do you have any type of degree or certification that enhances your skill as a prospective tutor? Tell us about it.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Do you have any teaching experience, if yes tell us when and where and if no, thats ok, you can still tell us about other experiences you have in the “Work Experience section”. Make sure you select the option that most describes your experience.
          </p>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-sm-12 col-lg-4">
          <h1 class="faded-number">3</h1>
          <div class="top-text">
            Verification
            <div class="mb-3 ml-4" style="font-size:17px">
              <span>
                <i class="fa fa-clock-o pr-2" style="color:#5f9048"></i>
              </span>
              <span style="padding-top:-20px">5 mins to complete (<small>Could Take 4 hours for your profile to be approved </small>)</span>
            </div>
          </div>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Upload a nice professional picture, link one of your social media accounts so we can verify you, upload an identification card, provide bank account details and put in the information of your referee.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> All the information you provide have to match. The images show you exactly what you need to do.
          </p>
          <p class="font-sm">
            <i>***We vouch that tutors can go to the homes of clients with good will and behaviour. For us to confidently make such commitments, we need to know as much about the tutor as possible. The same way clients trust us to bring in "unknown" tutors to their homes is thesame way they trust us to verify the said tutor’s identity. Trust that Preplcass will not share your bank account details with any third parties, we collect your account information and ID card strictly for verification purposes.</i>
          </p>
        </div>
        <div class="col-sm-12 col-lg-6 offset-lg-1 mt-3 mxfp-3">
          <b-carousel
            id="carousel-3"
            v-model="slide3"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            v-viewer
          >

            <!-- Slides with image only -->
            <b-carousel-slide img-src="static/Step3a.png">Click on select image (Swipe to see others)</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3b.png">Select and crop desired image</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3c.png">Save desired image</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3d.png">Choose desired social media account and follow instructions to link</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3ea1.png">See how to link your facebook</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3f.png">Upload ID card</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3g.png">Add Referee details</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3h.png">Wait for your Profile to be Approved</b-carousel-slide>
            <b-carousel-slide img-src="static/Step3i.png">Edit Subject Profile</b-carousel-slide>
          </b-carousel>

        </div>
      </div>

      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-sm-12 col-lg-6 mt-3 mxf-3">
          <b-carousel
            id="carousel-4"
            v-model="slide4"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            v-viewer
          >
            <!-- Slides with image only -->
            <b-carousel-slide img-src="static/Step4a.png">Select the days and time you will be available to teach(Swipe to see others)</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4a2.png">Input how much you want to be paid</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4a3.png">Use the calculator to familiarise yourself with our payment process</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4b1.png">Select the subject classes you want to teach</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4b2.png">Select specific subjects you can teach</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4b3.png">You can delete subjects at this point</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c.png">Click on write test to take the quiz for the selected subject</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c2.png">Read instructions for the test</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c1.png">Be sure you can complete the test in one sitting before you start</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c4.png">Write the test</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c5.png">Be sure you want to submit before clicking the submit button</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4b6.png">After passing a test, click on create a profile</b-carousel-slide>
            <b-carousel-slide img-src="static/Step4c6.png">Create a unique profile for every test passed</b-carousel-slide>
            <!-- <b-carousel-slide img-src="static/Step4c7.png"></b-carousel-slide> -->
            <!-- <b-carousel-slide img-src="static/Step4c8.png"></b-carousel-slide> -->
          </b-carousel>
        </div>
        <div class="col-sm-12 col-lg-4 offset-lg-1">
          <h1 class="faded-number">4</h1>
          <div class="top-text">
            Tutoring Information
            <div class="mb-3 ml-4" style="font-size:17px">
              <span>
                <i class="fa fa-clock-o pr-2" style="color:#5f9048"></i>
              </span>
              <span style="padding-top:-20px">30 - 45 mins to complete</span>
            </div>
          </div>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Now tell us what days and time you will be available to tutor and how much you expect to be paid for each class. We have a tutor calculator that can help you see exactly how these things work at Prepclass.
          </p>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i> Go ahead and select all the Class groups and Subject you can tutor efficiently, take the test for each subject and then create a profile for each test taken(it is important to write a separate profile for each subject because these subjects have different approaches and techniques. Furthermore, this information will be on your profile for prospective clients to see, make sure you impress them). If you fail a test that is ok, you can attempt the test 3 times, you can also practice and write it again after 3 months if you fail the 3 trials.
          </p>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-sm-12 col-lg-4">
          <h1 class="faded-number">5</h1>
          <div class="top-text">
            How it Works
          </div>
          <p class="font-sm">
            <i class="fa fa-check-circle pr-2"></i>Yayy. You have finally finished the registration process and this is your dashboard. Congratulations Prepclass Ng Tutor, you can now apply to any job post on our `Tutoring Jobs Page
            <link>that applies to you and better still, clients can now see and contact you for job offers. Good luck on your Prepclass journey.
          </p>
        </div>
        <div class="col-sm-12 col-lg-6 offset-lg-1 mt-3 mxf-3">
          <b-carousel
            id="carousel-5"
            v-model="slide5"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            v-viewer
          >
            <!-- Slides with image only -->
            <b-carousel-slide img-src="static/Done.png">There is a demo on how to navigate your profile once you get there</b-carousel-slide>
          </b-carousel>

        </div>

        <div class="mt-5">
          <img class src="../../../assets/hlover.svg" style="height:30px;width:30px;">
          <span class="h5">Video Guide</span>
          <video style="width:100%" class="mt-2 mx-auto border border-3 border-secondary" @ended="videoEnded()" controls>
              <source class="mx-auto" src="../../../../static/video_demo.mp4" type="video/mp4">
          </video>
        </div>

      </div>



      <button
        class="btn btn-lg btn-success float-right mb-lg-5 mt-lg-5 submit-button mobile-submit"
        @click="personal"
      >Next</button>
    </div>
  </div>
</template>

<script>
import momentzone from "moment-timezone";
import swal from "sweetalert";
import moment from "moment";
import axios from "axios";

export default {
  name: "welcome-setup",
  components: {},
  computed: {
    u() {
      return this.$auth.user();
    }
  },
  data() {
    return {
      slide1: 0,
      slide2: 0,
      slide3: 0,
      slide4: 0,
      slide5: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    videoEnded(){
     try {
      axios.post(`${BASE_API}/v1/tutor/profile/demo-video`)
      .then(() => swal(
            "Success",
            "Video Completely Watched! You can now proceed",
            "success"
          ))
     } catch (error) {
      console.error(error)
     }
    },
    saveAndContinue() {
      if (!this.u.progress.education) {
        return swal("Please complete the Education info setup");
      }
      if (!this.u.progress.teaching) {
        return swal("Please complete the teaching experience setup");
      }
      if (!this.u.progress.work) {
        return swal("Please complete the Work experience setup");
      }
      axios
        .post(`${BASE_API}/v1/tutor/steps`, { step: "educational_background" })
        .then(() => this.$store.dispatch("getUserTutor"));
      return this.$router.push({ name: "verification-setup" });
    },
    ac(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => this.$route.path.indexOf(path) >= 0);
    },
    async personal() {
      try {
        const { data: { status } } = await axios.get(`${BASE_API}/v1/tutor/profile/demo-video`);
        if(status === false) {
          return swal(
            "Sorry",
            "You have to watch the video completely before you can start your registration",
            "error"
          )
        }
        return this.$router.push({ name: "basic-setup" });
      } catch (error) {
        console.error(error)
      }
    },
    show(img) {
      console.log(img);
      this.$el.querySelector("#caro-1 img").$viewer.show();
    }
  },
  mounted() {
    if (this.$auth.user().verified) {
      const notification = {
        id: Math.floor(Math.random() * 100000 + 1),
        read: false,
        type: "warn",
        content: `Please note that if you make any edits you'll be unverified and you'll have to wait for re-verification.`,
        flag: "re-edit-warn",
        created_at: {
          date: moment().format("YYYY-MM-DD HH:mm:ss"),
          timezone: momentzone.tz.guess(),
          timezone_type: 3
        },
        created_by: "SYSTEM"
      };
      this.$emit("notify", notification);
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cont {
  padding: 15px 0;
}
.font-sm {
  font-size: 13px;
  text-align: justify;
}
.mxf-3 {
  margin-top: 120px !important;
}
.mxfp-3 {
  margin-top: 190px !important;
}
.img-btn {
  background: black;
  color: white;
  font-size: 40px;
  border-radius: 100px;
  width: 100px;
  opacity: 0.5;
  height: 100px;
  cursor: pointer;
}
.user {
  display: none !important;
}
.carousel-indicators .active {
  background: #5f9048 !important;
}
.carousel-indicators li {
  background: black !important;
  height: 7px;
  width: 7px;
  border-radius: 7px;
}
.img-btn:hover {
  background: black;
  opacity: 0.5;
}
.faded-number {
  font-size: 130px;
  color: #5f9048;
  opacity: 0.2;
  font-weight: 600;
}
.fixed-text {
  position: absolute;
  margin-left: -20px;
  margin-top: 10px;
}
.top-text {
  position: absolute;
  top: 55px;
  left: 50px;
  color: black;
  line-height: 24px;
  line-height: 2rem;
  font-size: 22px;
}
div.user {
  display: none !important;
}
h3.title {
  font-size: 20px;
  font-weight: 800;
  margin: 10px 0;
}
p.subtitle {
  margin: 5px 0;
  color: #2a2a2a;
  font-size: 16px;
}
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  float: right;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
    0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14),
      0 3px 1px -2px rgba(112, 112, 112, 0.12),
      0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {
      box-shadow: none !important;
    }
  }
}
.mx {
  margin: 0 10px;
}
.foot {
  margin-top: 30px;
}
.left-nav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1220px;
    position: relative;
    padding: 0;
    &::before {
      content: " ";
      position: absolute;
      height: 1px;
      width: calc(100% - 40px);
      display: block;
      top: 50%;
      left: 40px;
      background-color: rgba(0, 0, 0, 0.25);
      z-index: 0;
    }
    li {
      background-color: #fcfcfc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      z-index: 2;
      &.disabled {
        opacity: 1 !important;
        color: rgba(33, 37, 41, 0.6);
        span {
          opacity: 0.3;
        }
      }
      span {
        width: 50px;
        height: 50px;
        background-color: #f0f2f8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        padding: 10px 0;
        margin: 10px 0;
        cursor: pointer;
      }
      &:hover {
        color: #639440;
      }
      &.active {
        list-style-image: url(../../../assets/tick.svg);
        color: #639440;
        span {
          background-color: #639440;
          color: #fff;
        }
      }
    }
  }
  h1 {
    width: 100%;
  }
  p {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .submit-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    left: 0;
    border-radius: 0;
    text-transform: uppercase;
  }
  .mxf-3 {
    margin-top: 0px !important;
  }
  .mxfp-3 {
    margin-top: 0px !important;
  }
  .cont {
    padding: 0;
  }
  .left-nav {
    padding: 5px;
    ul {
      margin-bottom: 0;
      li {
        padding: 5px;
        font-size: 11px;
        span {
          height: 30px;
          width: 30px;
          background-color: #838383;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Setup/Demo.vue